<template>
  <component :is="footerRenderer" />
</template>

<script setup lang="ts">
import { computed, h } from "vue";
import type { ColumnFooterRenderer } from "@/components/controls/grid/BmGridData";

/**
 * Thin wrapper around column.footer — keeps the CreateElement-based
 * footer API without redesigning it for Vue 3 yet.
 */

interface BmGridFooterCellProps {
  footer: ColumnFooterRenderer;
}

const props = defineProps<BmGridFooterCellProps>();

const footerRenderer = computed(() => ({
  name: "BmGridFooterCellRenderer",
  render: () => props.footer(h),
}));
</script>
